export function uniqueIds<T>(items: T[], pick: (item: T) => string | null | undefined): string[] {
  return Array.from(new Set(items.map(pick).filter((id): id is string => Boolean(id))));
}

export async function hydrateById<T>(
  ids: string[],
  fetch: (id: string) => Promise<T>,
): Promise<Map<string, T>> {
  const hydrated = new Map<string, T>();

  await Promise.all(
    ids.map(async (id) => {
      const value = await fetch(id).catch(() => null);

      if (value !== null) {
        hydrated.set(id, value);
      }
    }),
  );

  return hydrated;
}
